import { render, staticRenderFns } from "./MainHolder.vue?vue&type=template&id=4a963d1e&scoped=true&"
import script from "./MainHolder.vue?vue&type=script&lang=js&"
export * from "./MainHolder.vue?vue&type=script&lang=js&"
import style0 from "./MainHolder.vue?vue&type=style&index=0&id=4a963d1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a963d1e",
  null
  
)

export default component.exports